<template>
<v-container :class="{'px-1': $vuetify.breakpoint.smAndDown}" my-1>
  <v-dialog max-width="500px" v-model="changeMakerValue">
    <change-maker
      :product="productsSelected"
      v-on:product-update="productUpdate($event)"
      v-on:close="closeChangeMarker()"
      v-on:error="onError"
      />
  </v-dialog>
  <v-card flat v-for="product in products" :key="product.id" >
  <ui-avg-product-row 
    :product="product"
    v-on:goDetails="selectProduct($event)"
    v-on:changeMaker="changeMaker($event)"
    ></ui-avg-product-row>
  <v-divider></v-divider>  
  </v-card>
</v-container>
</template>

<script>
import ChangeMaker from './ChangeMaker.vue';

export default {
  components: { ChangeMaker },
  props: ['products'],
  data() {
    return {
      changeMakerValue: false,
      productsSelected: {}
    };
  },
  methods: {
    productUpdate(product) {
      const index = this.products.findIndex(it => it.product_id === product.product_id)
      if(index >= 0){
        this.products[index].maker = product.maker
        this.products[index].maker_id = product.maker_id
      }
      this.closeChangeMarker()
      this.$emit('success', 'Marca actualizada correctamente')

    },
    closeChangeMarker(){
      this.changeMakerValue = false
      this.productsSelected = undefined
    },
    changeMaker(product){
      this.productsSelected = product
      this.changeMakerValue = true
    },
    selectProduct(product) {
      this.$emit('select-product', product);
    },
    onError(error){
      this.closeChangeMarker()
      this.$emit('error', error)
    }
  },
};
</script>
